
// Initialize logging first (must be before any other imports that might log)
import './lib/logger';

import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';


// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// Error handling for the entire app
const renderApp = () => {
  try {
    const container = document.getElementById("root");
    if (!container) {
      throw new Error("Root element not found!");
    }
    
    const root = createRoot(container);
    root.render(
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </HelmetProvider>
    );

  } catch (error) {
    console.error("Failed to render application:", error);
    // Display a fallback error UI
    document.body.innerHTML = `
      <div style="
        font-family: system-ui, -apple-system, sans-serif;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        padding: 20px;
        text-align: center;
      ">
        <h1>Something went wrong</h1>
        <p>The application failed to load. Please try refreshing the page.</p>
        <button onclick="window.location.reload()" style="
          background: #3b82f6;
          color: white;
          border: none;
          padding: 10px 16px;
          border-radius: 4px;
          cursor: pointer;
          margin-top: 20px;
        ">Refresh Page</button>
      </div>
    `;
  }
};

renderApp();
